import { mutateApi } from "src/utils/api/ApiMethods"

export const generateThoughtSpotToken = ({ marinaSlug, scope }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/analytics/token`,
    method: "POST",
    data: scope ? { scope } : {},
  })
}
